import { Button } from "primereact/button";
import React, { useState, useEffect } from 'react';
import { Steps } from 'primereact/steps';
import { Divider } from 'primereact/divider';
import { getFaqsByCategory } from "../services/faqService";
import CardHpIntro from "./card/CardHpIntro";
import CardHpTutorIntro from "./card/CardHpTutorIntro";
import CardRectangle from "./card/CardRectangle";
import FAQItem from "./faq/FAQItem";
import TrainerRegistrationForm from "./trainer/TrainerRegistrationForm";
import "/node_modules/flag-icons/css/flag-icons.min.css";
import "react-phone-input-2/lib/style.css";
import { getCurrentUserFromLocalStorage, getI18nLanguageFromLocalStorage } from "../helpers/localStorageHelper"
import { getCurrentLanguage } from "../helpers/languageHelper"
import { ConfirmDialog, confirmDialog } from "primereact/confirmdialog";
import { getTrainerRegisterStatusByUserId } from "../services/trainersService";
import { USER_ROLES } from "../constants/user-roles";
import { STATUS } from "../constants/trainer-constants";
import { getLocalizedField } from "../helpers/localizedHelper";
export default function TutorOnboarding({ props }) {
    const [isLoadingFaqs, setIsLoadingFaqs] = useState(false);
    const [filteredFaqs, setFilteredFaqs] = useState([]);
    const [expandedQuestionId, setExpandedQuestionId] = useState(null);
    const [visible, setVisible] = useState(false);
    const [showConfirm, setShowConfirm] = useState(false);
    const [currentUserStatus, setCurrentUserStatus] = useState(null);
    const currentUser = getCurrentUserFromLocalStorage();
    const [isLoading, setIsLoading] = useState(true);
    const language = getI18nLanguageFromLocalStorage();

    const items = [
        {
            disabled: false,
            label: `${props.tutorOnboardingBanner.stepLabel1}`,
            template: (item) => itemRenderer(item, 0)
        },
        {
            disabled: false,
            label: `${props.tutorOnboardingBanner.stepLabel2}`,
            template: (item) => itemRenderer(item, 1)
        },
        {
            disabled: false,
            label: `${props.tutorOnboardingBanner.stepLabel3}`,
            template: (item) => itemRenderer(item, 2)
        },
    ];

    const itemRenderer = (item, itemIndex) => {
        const backgroundColor = `var(--primary-primary-${itemIndex === 0 ? 0 : itemIndex + 1})`;

        return (
            <div className="flex flex-column gap-0625 justify-content-center align-items-center">
                <span
                    className="inline-flex align-items-center justify-content-center kedual-step text-default-txt step-square align-items-center keduall-typography heading-h3-semibold-600 py-2"
                    style={{ backgroundColor: backgroundColor }}
                >
                    {itemIndex + 1}
                </span>
                <p className="keduall-typography text-16-medium-500 flex text-center mb-3">
                    {item.label}
                </p>
            </div>
        );
    };

    useEffect(() => {
        if (currentUserStatus) {
            setIsLoading(false);
        }
    }, [currentUserStatus])

    useEffect(() => {
        const loadFaqs = async () => {
            try {
                setIsLoadingFaqs(true);
                // TODO: Get trainer category after FQA category was refatored
                const faqs = await getFaqsByCategory(null, null, props.qaSession.search);
                setFilteredFaqs(faqs.data);
            } catch (err) {

            } finally {
                setIsLoadingFaqs(false);
            }
        };

        loadFaqs();

        const loadTrainerStatus = async () => {
            try {
                if (currentUser) {
                    const res = await getTrainerRegisterStatusByUserId(currentUser.id);
                    if (res) {
                        if (res !== STATUS.Draft) {
                            setCurrentUserStatus({ isTrainer: true, status: res })
                            return;
                        }
                    }
                };
                setCurrentUserStatus({ isTrainer: false, status: "" })
            } catch {
                setCurrentUserStatus({ isTrainer: false, status: "" })
            }
        };
        loadTrainerStatus();
    }, []);

    useEffect(() => {
        if (!isLoading && props.isOpenForm === "True") {
            showTrainerRegisterModal();
        }
    }, [isLoading])

    const toggleQuestion = (qId) => {
        setExpandedQuestionId((prev) => (prev === qId ? null : qId));
    };

    const trainerDashboardUrl = props?.portalUrls?.trainerPortal ?? "/portals/trainer"

    const goToTrainerDashboard = () => {
        setShowConfirm(false)
        window.location.href = trainerDashboardUrl
    }
    const showTrainerRegisterModal = () => {
        if (!currentUser) {
            const selectedLanguage = getCurrentLanguage();
            // window.location.href = `/auth/login?lang=${selectedLanguage}&returnUrl=/${selectedLanguage}/tutor-onboarding?isOpenForm=true`
            window.location.href = `/${selectedLanguage}/register?next=auto_login&returnUrl=/${selectedLanguage}/tutor-onboarding?isOpenForm=true`
            return;
        }

        if (!currentUserStatus.isTrainer || currentUserStatus.status === STATUS.Rejected) {
            setVisible(true);
            return;
        }

        showConfirmDialog(currentUserStatus.status);
    };

    const showConfirmDialog = (status) => {
        if (status === STATUS.WaitingForApproval) {
            confirmDialog({
                header: props.confirmDialog.onWaiting.header,
                message: props.confirmDialog.onWaiting.message,
                closable: false,
                footer: (
                    <div className="flex justify-content-end">
                        <Button className="keduall-buttons button-filled-default-normal-primary" onClick={() => setShowConfirm()}>
                            <p className="keduall-typography text-16-semibold-600 white-color">{props.confirmDialog.onWaiting.button}</p>
                        </Button>
                    </div>
                )
            });
            setShowConfirm(true);
            return;
        }

        // approved trainer
        confirmDialog({
            header: props.confirmDialog.onApproved.header,
            message: props.confirmDialog.onApproved.message,
            footer: (
                <div className="flex justify-content-end">
                    <Button className="keduall-buttons button-filled-default-normal-primary" onClick={() => goToTrainerDashboard()}>
                        <p className="keduall-typography text-16-semibold-600 white-color">{props.confirmDialog.onApproved.button}</p>
                    </Button>
                </div>
            )
        });
        setShowConfirm(true);
    }

    return (
        isLoading ? <div></div>
            : !visible ? <div className="become-tutor-container  main-content-wrapper">
                <ConfirmDialog
                    className="keduall-confirm-dialog"
                    visible={showConfirm}
                    draggable={false} 
                    onHide={() => setShowConfirm(false)}
                />

                {/* Titel */}
                <div className="gap-075 flex flex-column">
                    <div className="w-full">
                        <div className="flex justify-content-center">
                            <h2 className="keduall-typography text-primary-default t heading-h2-semibold-600 flex justify-content-center text-center animate__animated animate__fadeInDown">
                                {props.tutorOnboardingTitle}
                            </h2>
                        </div>
                    </div>
                    <div className="w-full mb-5">
                        <div className="keduall-typography text-default-txt heading-h5-semibold-600 flex justify-content-center text-center animate__animated animate__fadeInDown">{props.tutorOnboardingTitleDescription}</div>
                    </div>
                </div>
                {/* Banner */}
                <div className="grid w-full pb-45">
                    <div className="col-12 lg:col-8 flex flex-wrap md:flex-nowrap justify-content-center align-items-center">
                        <div className="gap-25 flex flex-column justify-content-center align-items-center">
                            <div className="flex justify-content-start w-full">
                                <div className="keduall-typography text-16-normal-400 animate__animated animate__fadeInDown animate__delay-1s white-space-break-spaces">{props.tutorOnboardingBanner.title}</div>
                            </div>
                            <div className="flex flex-column gap-4 w-full">
                                <div className="keduall-typography heading-h5-semibold-600 animate__animated animate__fadeInDown animate__delay-2s">{props.tutorOnboardingBanner.description}</div>
                                <Steps
                                    model={items}
                                    className="kedual-step step-custom no-opacity animate__animated animate__fadeInDown animate__delay-3s"
                                ></Steps>
                            </div>
                            <Button className="keduall-buttons button-filled-default-large-primary keduall-typography text-16-semibold-600 animate__animated animate__fadeInDown animate__delay-4s" label={props.tutorOnboardingBanner.button} onClick={() => showTrainerRegisterModal()} />
                        </div>
                    </div>
                    <div className="col-12 lg:col-4 text-center">
                        <img src={props.tutorOnboardingBanner.imgUrl} className="m-auto h-full animate__animated animate__fadeInRight animate__delay-2s w-full" alt="" style={{objectFit: "cover"}}></img>
                    </div>
                </div>

                {/* Recommend */}
                <div className="flex flex-column justify-content-center align-items-center gap-6">
                    <div className="flex flex-column justify-content-center align-items-center gap-075 animate-on-scroll">
                        <div className="flex keduall-typography heading-h3-semibold-600 text-primary-default">{props.recommend.title}</div>
                        <div className="flex flex-row flex-wrap md:flex-nowrap justify-content-center align-items-center gap-1 keduall-typography heading-h5-normal-400">
                            <div className="flex diff-color-50 h-auto h-12 keduall-typography text-16-normal-400">{props.recommend.subTitle1}</div>
                            <div className="flex h-auto keduall-typography text-16-normal-400">{props.recommend.subTitle2}</div>
                        </div>
                    </div>
                    <div className="grid">
                        {/* Row 1 */}
                        <div className="col-12 lg:col-6 p-3">
                            <CardHpIntro
                                title={props.recommend.card1.title}
                                description={props.recommend.card1.description}
                                image={props.recommend.card1.image}
                                backgroundColor="#FFF2E7"
                            />
                        </div>
                        <div className="col-12 lg:col-6 p-3">
                            <CardHpIntro
                                title={props.recommend.card2.title}
                                description={props.recommend.card2.description}
                                image={props.recommend.card2.image}
                                backgroundColor="#FFF5D7"
                            />
                        </div>
                        {/* Row 2 */}
                        <div className="col-12 lg:col-6 p-3">
                            <CardHpIntro
                                title={props.recommend.card3.title}
                                description={props.recommend.card3.description}
                                image={props.recommend.card3.image}
                                backgroundColor="#FFD7B6"
                            />
                        </div>
                        <div className="col-12 lg:col-6 p-3">
                            <CardHpIntro
                                title={props.recommend.card4.title}
                                description={props.recommend.card4.description}
                                image={props.recommend.card4.image}
                                backgroundColor="#FFAB5F"
                            />
                        </div>
                    </div>
                </div>

                <Divider className="py-45"></Divider>

                {/* Korean instructor 1 */}
                <div className="flex flex-column justify-content-center align-items-center gap-6">
                    <div className="flex flex-column justify-content-center align-items-center gap-075 animate-on-scroll">
                        <div className="flex keduall-typography heading-h3-semibold-600 text-primary-default text-center">{props.instructor1.title}</div>
                        <div className="flex keduall-typography text-16-normal-400 text-center">
                            {props.instructor1.subTitle}
                        </div>
                    </div>
                    <div className="grid">
                        {/* Row 1 */}
                        <div className="col-12 lg:col-6 xl:col-3 p-3">
                            <CardHpTutorIntro
                                title={props.instructor1.card1.title}
                                description={props.instructor1.card1.description}
                                image={props.instructor1.card1.image}
                            />
                        </div>
                        <div className="col-12 lg:col-6 xl:col-3 p-3">
                            <CardHpTutorIntro
                                title={props.instructor1.card2.title}
                                description={props.instructor1.card2.description}
                                image={props.instructor1.card2.image}
                            />
                        </div>
                        <div className="col-12 lg:col-6 xl:col-3 p-3">
                            <CardHpTutorIntro
                                title={props.instructor1.card3.title}
                                description={props.instructor1.card3.description}
                                image={props.instructor1.card3.image}
                            />
                        </div>
                        <div className="col-12 lg:col-6 xl:col-3 p-3">   
                            <CardHpTutorIntro
                                title={props.instructor1.card4.title}
                                description={props.instructor1.card4.description}
                                image={props.instructor1.card4.image}
                            />
                        </div>
                    </div>
                </div>

                <Divider className="py-45"></Divider>

                {/* Korean instructor 2 */}
                <div className="flex flex-column justify-content-center align-items-center gap-6">
                    <div className="flex flex-column justify-content-center align-items-center gap-075 animate-on-scroll">
                        <div className="flex keduall-typography heading-h3-semibold-600 text-primary-default text-center">{props.instructor2.title}</div>
                        <div className="flex keduall-typography text-16-normal-400 text-center">
                            {props.instructor2.subTitle}
                        </div>
                    </div>
                    <div className="grid w-full">
                        {/* Row 1 */}
                        <div className="col-12 lg:col-6">
                            <CardRectangle
                                title={props.instructor2.card1.title}
                                description={props.instructor2.card1.description}
                            />

                            <CardRectangle
                                title={props.instructor2.card2.title}
                                description={props.instructor2.card2.description}
                            />
                        </div>

                        {/* Row 2 */}
                        <div className="col-12 lg:col-6">
                            <CardRectangle
                                title={props.instructor2.card3.title}
                                description={props.instructor2.card3.description}
                            />

                            <CardRectangle
                                title={props.instructor2.card4.title}
                                description={props.instructor2.card4.description}
                            />
                        </div>
                    </div>
                </div>

                <Divider className="py-45"></Divider>

                {/* Sesion */}
                <div className="flex flex-column justify-content-center align-items-center gap-6">
                    <div className="flex flex-column justify-content-center align-items-center gap-075 animate-on-scroll">
                        <div className="flex keduall-typography heading-h3-semibold-600 text-primary-default text-center">{props.tutorOnboardingSession1.title}</div>
                        <div className="flex keduall-typography text-16-normal-400 text-center">
                            {props.tutorOnboardingSession1.subTitle}
                        </div>
                    </div>
                    <div className="flex flex-row flex-wrap md:flex-nowrap justify-content-center align-items-center gap-45">
                        <img src={props.tutorOnboardingSession1.imgUrl} alt="" style={{maxWidth: "100%"}}></img>
                        <div>
                            <div className="flex gap-4 mb-6">
                                <img src={props.tutorOnboardingSession1.section1.image} className="w40 h40 flex justify-content-center" alt=""></img>
                                <div>
                                    <div className="mb-2 keduall-typography heading-h5-semibold-600">{props.tutorOnboardingSession1.section1.title}</div>
                                    <div className="keduall-typography text-16-normal-400">{props.tutorOnboardingSession1.section1.description}</div>
                                </div>
                            </div>
                            <div className="flex gap-4 mb-6">
                                <img src={props.tutorOnboardingSession1.section2.image} className="w40 h40 flex justify-content-center" alt=""></img>
                                <div>
                                    <div className="mb-2 keduall-typography heading-h5-semibold-600">{props.tutorOnboardingSession1.section2.title}</div>
                                    <div className="keduall-typography text-16-normal-400">{props.tutorOnboardingSession1.section2.description}</div>
                                </div>
                            </div>
                            <div className="flex gap-4 mb-6">
                                <img src={props.tutorOnboardingSession1.section3.image} className="w40 h40 flex justify-content-center" alt=""></img>
                                <div>
                                    <div className="mb-2 keduall-typography heading-h5-semibold-600">{props.tutorOnboardingSession1.section3.title}</div>
                                    <div className="keduall-typography text-16-normal-400">{props.tutorOnboardingSession1.section3.description}</div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <Divider className="py-45"></Divider>

                {/* QA */}
                <div className="flex flex-column justify-content-center align-items-center gap-6 pb-45">
                    <div className="flex flex-column justify-content-center align-items-center gap-075 animate-on-scroll">
                        <div className="flex keduall-typography heading-h3-semibold-600 text-primary-default text-center">{props.qaSession.title}</div>
                        <div className="flex keduall-typography text-16-normal-400 text-center">
                            {props.qaSession.subTitle}
                        </div>
                    </div>
                    <div className="flex flex-column justify-content-center align-items-center gap-25 md:px-725 w-full">
                        <div className="faq-right-col">
                            {isLoadingFaqs ? (
                                <div className="loading-indicator">
                                    <i className="pi pi-spin pi-spinner"></i>
                                </div>
                            ) : (
                                <>
                                    {(
                                        filteredFaqs.map((faq) => {
                                            const isExpanded = expandedQuestionId === faq.id;
                                            const question = getLocalizedField(faq, "question", language);
                                            const answer = getLocalizedField(faq, "answer", language);
                                            return (
                                                <FAQItem
                                                    key={faq.id}
                                                    props={{ ...faq, question, answer }}
                                                    isExpanded={isExpanded}
                                                    onClick={toggleQuestion}
                                                />
                                            );
                                        })
                                    )}
                                </>
                            )}
                        </div>
                    </div>
                </div>
            </div> : <TrainerRegistrationForm
                    props={props.trainerRegister}
                    setVisible={setVisible}
                />
    )
}